<form class="sgt-usuario-permissao-plm" #form="ngForm" novalidade>
    <div class="card">
        <div class="card-header">
            <h6 class="card-title mb-0">
                PLM
            </h6>
           <small class="card-subtitle">Selecione as permissões que este usuário tem acesso na gestão do ciclo de vida do produto</small>
        </div>

        <ul class="list-group list-group-flush" *ngIf="entity">
            <li class="list-group-item">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.podeEditarDadosPLM" name="podeEditarDadosPLM" id="podeEditarDadosPLM">
                    <label class="custom-control-label" for="podeEditarDadosPLM">Editar Dados de PLM</label>
                </div>
                <p class="form-text text-muted">Selecione esta opção se o usuário pode alterar os dados de PLM do produto — datas da jornada, tipo estratégico, DNA, parâmetros de expectativa e classificação no R.A.P.</p>
            </li>
            <li class="list-group-item">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.podeAcompanharGatesPLM" name="podeAcompanharGatesPLM" id="podeAcompanharGatesPLM">
                    <label class="custom-control-label" for="podeAcompanharGatesPLM">Acompanhar Gates do PLM</label>
                </div>
                <p class="form-text text-muted">Selecione esta opção se o usuário pode consultar a fila de decisões pendentes e a trilha de eventos dos produtos, sem registrar decisão.</p>
            </li>
            <li class="list-group-item">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.podeDecidirGatesPLM" name="podeDecidirGatesPLM" id="podeDecidirGatesPLM">
                    <label class="custom-control-label" for="podeDecidirGatesPLM">Decidir Gates do PLM</label>
                </div>
                <p class="form-text text-muted">Selecione esta opção se o usuário pode registrar a Certificação de Maturidade, a Revisão de Maturidade e a revitalização ou o reposicionamento de um produto.</p>
            </li>
            <li class="list-group-item">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" [(ngModel)]="entity.podeEncerrarProdutoPLM" name="podeEncerrarProdutoPLM" id="podeEncerrarProdutoPLM">
                    <label class="custom-control-label" for="podeEncerrarProdutoPLM">Encerrar Produto</label>
                </div>
                <p class="form-text text-muted">Selecione esta opção se o usuário pode descontinuar um produto. É a única decisão irreversível do ciclo de vida, por isso tem permissão própria.</p>
            </li>
        </ul>
    </div>
</form>
